import { render, staticRenderFns } from "./DingOpen.vue?vue&type=template&id=3fc098c5&scoped=true"
import script from "./DingOpen.vue?vue&type=script&lang=js"
export * from "./DingOpen.vue?vue&type=script&lang=js"
import style0 from "./DingOpen.vue?vue&type=style&index=0&id=3fc098c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc098c5",
  null
  
)

export default component.exports